
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCan from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "CentroCustoIndex",
  components: { Pencil, TrashCan },
  data() {
    return {
      centros: [],
      busca: "",
      incluirInativos: true,
      carregando: false,
      salvando: false,
      modalAberto: false,
      form: { id: null, nome: "", ativo: true },
    };
  },
  computed: {
    centrosFiltrados() {
      const busca = this.busca.trim().toLocaleLowerCase("pt-BR");
      return busca
        ? this.centros.filter((centro) => (centro.nome || "").toLocaleLowerCase("pt-BR").includes(busca))
        : this.centros;
    },
  },
  created() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await this.$http.post("/financeiro/centros-custos/lista", {
          incluir_inativos: this.incluirInativos,
        });
        this.centros = Array.isArray(data) ? data : data.data || [];
      } finally {
        this.carregando = false;
      }
    },
    abrirCadastro(centro = null) {
      this.form = centro
        ? { id: centro.id, nome: centro.nome, ativo: !!centro.ativo }
        : { id: null, nome: "", ativo: true };
      this.modalAberto = true;
    },
    async salvar() {
      if (!this.form.nome) return;
      this.salvando = true;
      try {
        const endpoint = this.form.id
          ? "/financeiro/centros-custos/update"
          : "/financeiro/centros-custos/create";
        await this.$http.post(endpoint, this.form);
        this.modalAberto = false;
        await this.carregar();
        this.$toast.success("Centro de custo salvo com sucesso!");
      } finally {
        this.salvando = false;
      }
    },
    async excluir(centro) {
      const resultado = await this.$swal.fire({
        icon: "warning",
        title: `Excluir o centro de custo ${centro.nome}?`,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        confirmButtonColor: "#f64e60",
      });
      if (!resultado.isConfirmed) return;
      await this.$http.post("/financeiro/centros-custos/delete", { id: centro.id });
      await this.carregar();
      this.$toast.success("Centro de custo excluído!");
    },
  },
};
